import React from 'react';
import PointerData from 'components/PointerData';
import DigitsData from 'components/DigitsData';

export default class ImageData extends React.Component {
  render() {
    const Row = (props) => (
      <tr>
        <th>{props.title}</th>
        <td>{props.value}</td>
      </tr>
    );

    return (
      <div className="ImageData">
        {this.props.errObj ? <p className="error">Error: {this.props.errObj.message || this.props.errObj }</p> : null}
        {this.props.digitsConfigWarning && <div className='warning'>{this.props.digitsConfigWarning}</div>}
        {this.props.pointersConfigWarning && <div className='warning'>{this.props.pointersConfigWarning}</div>}
        <table>
            <tbody>
              <Row title="Source" value={this.props.source} />
              <Row title="Timestamp" value={this.props.timestamp} />
              {this.props.tab === "red" && <Row title="Red %" value={this.props.redPercentage} /> }
              {this.props.tab === "red" && <Row title="Red threshold" value={this.props.redTreshold} />}
              {this.props.tab !== "digits" && <Row title="Pointer value" value={this.props.value} />}
              {this.props.tab !== "decimal" && <Row title="Digit integer value" value={this.props.digitIntegerRawValue} />}
              {this.props.tab !== "decimal" && <Row title="Digit decimal value" value={this.props.digitDecimalRawValue} />}
            </tbody>
        </table>
        {this.props.tab === "decimal" && <PointerData {...this.props} />}
        {this.props.tab === "digits" && <DigitsData {...this.props} />}
        {this.props.children}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./client/components/ImageData.js